import React, { useState } from 'react'
import { Segmented,Form,Input,Button, message } from 'antd'
import { SERVER_ADDRESS } from '../../Config/Config'
import axios from 'axios'

const AddData = () => {
    const [selectedOption,setSelectedOption] = useState('Maritial Status')
    const options = ['Maritial Status', 'Work Sector', 'Occupation', 'Designation','Annual Income', 'Mother Tongue', 'Religion', 'Caste','Raasi','Star','Languages','Gothram','Dosham']
    const [form] = Form.useForm()

    const handleData = async(values)=>{
        const payload = {
            key:selectedOption,
            ...values
        }
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/addData`,payload)
            if(response.status===200){
                if(response.data.result === 1){
                    message.success({content:`${response.data.message}`})
                    form.resetFields();
                }
                if(response.data.result === 0){
                    message.warning({content:`${response.data.message}`})
                }
            }
        } catch (error) {
            message.error({content:"Something Went Wrong !"})
        }
        
    }

    const renderForm = () => (
        <Form form={form} onFinish={handleData} key={selectedOption}>
          <Form.Item label={selectedOption} labelCol={{ span: 3 }} wrapperCol={{ span: 10 }} name={selectedOption.toLowerCase().replace(/\s+/g, '_')} rules={[{ required: true, message: `Enter ${selectedOption}` }]}>
            <Input placeholder={`Enter ${selectedOption}`} />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 5 }}>
            <Button type='primary' htmlType='submit' variant='filled'>Submit</Button>
          </Form.Item>
        </Form>
      )
    

  return (
    <div style={{marginTop:'4rem'}} >
        <Segmented value={selectedOption} options={options} onChange={setSelectedOption} />
        <div className='mt-3 p-4' style={{backgroundColor:"white",borderRadius:"1rem"}} >
        <h3 className='py-4' >{selectedOption} Form</h3>
            {renderForm()} 
        </div>
    </div>
  )
}

export default AddData